// @flow
import {compose, reject, propEq} from 'ramda'

import liftNodes from 'utils/GraphQL/typedLiftNodes'
import {makeItems} from '../../Item'
import type {Change} from '../types'

const liftRoles = (obj) => liftNodes(obj.circleRoles)
const liftPolicies = (obj) => liftNodes(obj.circlePolicies)
const rolesWithoutRejected = (rejectedRole: Object) => compose(reject(propEq('databaseId', rejectedRole?.databaseId)), liftRoles)

function fetchFieldsFromChange({
  role: parent,
  childSupportedRole: child,
  rolesToMoveUp,
  rolesToMoveDown,
  policiesToMoveUp,
  policiesToMoveDown,
}: Change): Object {
  return {
    role: parent,
    childSupportedRole: child,
    rolesToMoveUp: makeItems(liftRoles, child, rolesToMoveUp),
    rolesToMoveDown: makeItems(rolesWithoutRejected(child), parent, rolesToMoveDown),
    policiesToMoveUp: makeItems(liftPolicies, child, policiesToMoveUp),
    policiesToMoveDown: makeItems(liftPolicies, parent, policiesToMoveDown),
  }
}

export default fetchFieldsFromChange
